import { AppThunk } from "@Store/index";
import urljoin from "helpers/urljoin";

import config from "@Config/index";
import fetchInventory from "./fetchInventory";
import getPropertyLink from "@Pages/PropertyPage/data/helper";
import fetchOffers from "@Pages/PropertyPage/data/fetchOffers";
import {
  getBookFormPageError,
  getBookFormPageRequesting,
  getBookFormPageSuccess,
} from "./bookFormReducer";
import getCustomForm from "./getCustomForm";
import isPaymentActive from "@Utils/isPaymentActive";
// import setCookieForBookFormHappyFlow from "helpers/setCookieForBookFormHappyflow";
import { updateProviderId } from "@App/appReducer";
import customWindowLocation from "@Utils/customWindowLocation";
// import getCookie from "helpers/getCookie";

const getBookFormPageData =
  ({ id, staticContext, isSuccessPage }: any): AppThunk =>
  async (dispatch, getState) => {
    dispatch(getBookFormPageRequesting({ id, isSuccessPage }));
    const { userCurrency, userLanguage } = getState().appData;
    // const token = userData?.token || getCookie("user_auth_token");
    try {
      const [invRes, offersRes]: any = await Promise.all([
        fetchInventory({
          id,
          user_currency: userCurrency,
          selectedLang: userLanguage,
        }),
        fetchOffers({
          id,
          selectedLang: userLanguage,
          userCurrency,
        }),
      ]);

      const inventoryData = invRes.data.data;
      inventoryData["active_offers"] = offersRes?.data?.data;
      const inventoryUrl = urljoin(config.WEB_SERVICE_URL, getPropertyLink(inventoryData, {}));
      inventoryData["inventoryUrl"] = inventoryUrl;

      if (inventoryData.parent_id) {
        throw new Error(`'Inventory Child: ', ${id}`);
      }

      // Deleted inventories. Pass 404 as the status message.
      if (inventoryData.status == "deleted" && !isSuccessPage) {
        if (inventoryData.region?.canonical_name) {
          staticContext.url = `/places/search/${inventoryData.region.canonical_name}`;
        } else {
          staticContext.url = `/`;
        }
        if (__CLIENT__) customWindowLocation({ url: staticContext.url });
        return null;
      }

      // Check if the canonical url is valid
      if (id != inventoryData.canonical_name && !isSuccessPage) {
        staticContext.url = getPropertyLink(inventoryData, {});
        if (__CLIENT__) customWindowLocation({ url: staticContext.url });
        return null;
      }

      // const meta: any = {};
      const isUSA = inventoryData?.location?.country?.long_name === "United States";

      let customFormInfo: any = {};
      if (inventoryData.inventory_custom_form?.data) {
        customFormInfo = getCustomForm(
          inventoryData.inventory_custom_form?.data,
          isUSA,
          inventoryData.meta?.guarantor_required === "false",
        );
      }

      const skipGuarantorDetails =
        inventoryData.location?.country?.long_name === "Australia" ||
        inventoryData.location?.country?.long_name === "Canada" ||
        inventoryData.meta?.guarantor_required === "false";

      const paymentActive = isPaymentActive(inventoryData);

      // making new bookform live for all users, hence removing cookie
      // if (!__CLIENT__) {
      //   setCookieForBookFormHappyFlow(
      //     inventoryData?.location?.locality?.long_name,
      //     staticContext,
      //     req,
      //     inventoryData?.location?.country?.short_name,
      //     inventoryData?.region_id,
      //   );
      // }

      dispatch(updateProviderId({ providerId: `${inventoryData?.provider_id}` }));
      dispatch(
        getBookFormPageSuccess({
          data: invRes?.data?.data,
          inventoryForm: customFormInfo?.inventoryForm || {},
          isCustomFormEnabled: customFormInfo?.isCustomFormEnabled || false,
          isCustomFormAfterPaymentEnabled: customFormInfo?.isCustomFormAfterPaymentEnabled || false,
          formSectionObj: customFormInfo?.formSectionObj || {},
          formSectionObjAfterPayment: customFormInfo?.formSectionObjAfterPayment || {},
          paymentActive,
          skipGuarantorDetails,
        }),
      );
      return null;
    } catch (err) {
      console.error(err);
      return dispatch(getBookFormPageError(JSON.stringify(err)));
    }
  };

export default getBookFormPageData;
